import { ProjectContextRoute } from "@/features/projects/project-context/project-context-route";
import { createFileRoute } from "@tanstack/react-router";

// CR-297: owner/admin page for the project's AI context sources (gate in ProjectContextRoute).
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/project-context",
)({
  component: ProjectContextRoute,
});
